<template>
  <!--    课程-->
  <div class="course-modules">
    <div class="title-box">
      <div class="title-txt">{{param.title}}</div>
      <div class="title-box-line"></div>
    </div>
    <div class="course-modules-list">
      <a :href="item.url" v-for="(item,index) in param.data" class="info-course-box course-modules-item left-justifying" :key="index" style="align-items: self-start;">
        <van-image :src="item.cover" alt="" class="course-img" lazy-load />
        <div class="course-info">
          <div class="title-box-course">{{item.title}}
          </div>
          <div class="tag-box left-justifying">
            <div class="tag-item" v-for="(tag,index) in item.keywords" :key="index">{{tag}}</div>
          </div>
        </div>
      </a>
    </div>
    <!--      <a v-for="(item,index) in courseList" :href="item.url" :key="index">{{item.name}}</a>-->
  </div>
</template>

<script>
import Vue from 'vue'
import { Lazyload } from 'vant' // 导入懒加载模块Lazyload
Vue.use(Lazyload) // 注册懒加载指令
export default {
  name: "course",
  props:['param'],

}
</script>

<style lang="scss" scoped>
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
.course-modules{
  text-align: left;
  width: 696px;margin: auto auto;
  .title-box{
    text-align: left;margin-left: 0;
    .title-txt{
      text-align: left;
      width: 480px;
    }
    .title-box-line{
      width: 410px;
    }
  }
  .course-modules-list{
    .course-modules-item{
      background: #ffffff;padding: 20px;
      position: relative;
      margin-bottom: 20px;
      .course-img{
        width: 250px;
        height: 150px;
        //background: #8C8C8C;
        border-radius: 10px;display: block;margin-right: 20px;
      }
      .course-info{
        width: 400px;
        .title-box-course{
          font-weight: 400;
          color: #1D1D1D;
          line-height: 36px;text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;font-size: 28px;
        }
        .tag-box{
          margin-top: 30px;position: absolute; left: 280px;bottom: 20px;width: 390px;
          .tag-item{
            padding: 5px 10px;

            background: #FFF4BE;font-size: 18px;color: #EDA10E;
            border-radius: 5px;margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
